import React from 'react';
import { Role } from '../../api/llmapi';
import { Conversation } from '../../../fasades/conversation';
import { Message } from '../../chat/message';
import { TextAreaResize } from '../textarearesize';
import { IoMdArrowRoundForward } from "react-icons/io";
import './styles.css';
import './chatinput.css';
import { RoundButton } from '../roundbutton';

interface ChatInputProps {
  updateTrigger?: number;
}

interface ChatInputState {
  input: string;
}

class ChatInput extends React.Component<ChatInputProps, ChatInputState> {
    private textInput : React.RefObject<TextAreaResize|null>;

    constructor(props: ChatInputProps) 
    {
        super(props);
        this.textInput = React.createRef<TextAreaResize>();
        this.state = {
          input: ''
        };
    }

    componentDidMount()
    {
        this.textInput.current!.focus();
    }

    handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const { input } = this.state;

        if (input.trim() === '' || Conversation.loading) return;

        // Add user message to the chat
        Conversation.addMessage(new Message(Role.User, input));

        // Get Reply
        const messages = Conversation.getMessages();
        await Conversation.getReply(messages);

        // Reset input
        this.setState({ input: '' });
    };

    handleInputChange = (text: string) => {
        this.setState({ input: text });
    };

    componentDidUpdate(prevProps: ChatInputProps) {
        // If you need to do something when updateTrigger changes
        if (this.props.updateTrigger !== prevProps.updateTrigger) {
          // Add any necessary logic
        }
    }

    async onEnter()
    {
        const { input } = this.state;

        // Reset input
        this.setState({ input: '' });

        if (input.trim() === '' || Conversation.loading) return;

        // Add user message to the chat
        Conversation.addMessage(new Message(Role.User, input));

        // Get Reply
        const messages = Conversation.getMessages();
        await Conversation.getReply(messages);
    }

    render() {
        const { input } = this.state;

        return (
            <div className="chat-input-form">
                <TextAreaResize
                    ref={this.textInput}
                    key="edit-textarea"
                    onChange={(text :string) => this.handleInputChange(text) }
                    onEnter={ () => this.onEnter() }
                    text={input}
                    editMode={true}
                    className="input-text"/>
                <div className="chat-input-actions">
                    <RoundButton
                        disabled={this.state.input.length === 0}
                        className={"chat-input-submit"}
                        icon={IoMdArrowRoundForward}
                        size={30}
                        onClick={() => this.onEnter() }/>
                </div>
          </div>
        );
    }
}

export default ChatInput;

